import {Component, OnInit, ViewChild} from '@angular/core';
import {UserService} from 'src/app/services/user/user.service';
import {TeamModel} from 'src/app/models/team.model';
import {ApiResponse} from 'src/app/services/utils';
import {SwiperComponent} from 'swiper/angular';
import {IonContent, IonSearchbar, NavController} from '@ionic/angular';
import {TeamService} from 'src/app/services/team/team.service';
import {SwiperOptions} from 'swiper';
import {UserModel} from 'src/app/models/user.model';
import {AuthService} from 'src/app/services/auth/auth.service';
import {CompanyModel} from 'src/app/models/company.model';
import {CompanyService} from 'src/app/services/company/company.service';
import {FormControl} from '@angular/forms';
import {SearchService} from '../../services/search/search.service';
import {GlobalService} from 'src/app/services/global/global.service';

@Component({
  selector: 'app-team',
  templateUrl: 'team.page.html',
  styleUrls: ['team.page.scss'],
  standalone: false
})
export class TeamPage implements OnInit {
  @ViewChild(IonContent, {static: false}) teamContent: IonContent;

  @ViewChild('swiper') swiper: SwiperComponent | undefined;

  @ViewChild('myTeamsSearchbar') myTeamsSearchBarId: IonSearchbar;
  @ViewChild('teamsMemberOfSearchbar') teamsMemberOfSearchbarId: IonSearchbar;
  @ViewChild('exploreTeamsSearchbar') exploreTeamsSearchbarId: IonSearchbar;
  @ViewChild('teamsInvitationSearchbar') teamsInvitationsSearchbarId: IonSearchbar;
  @ViewChild('myCompaniesSearchbar') myCompaniesSearchbarId: IonSearchbar;
  @ViewChild('companiesYouFollowSearchbar') companiesYouFollowSearchbarId: IonSearchbar;
  @ViewChild('exploreCompaniesSearchbar') exploreCompaniesSearchbarId: IonSearchbar;


  public searchFieldMyTeams: FormControl;
  public searchFieldTeamsMemberOf: FormControl;
  public searchFieldAllTeams: FormControl;
  public searchFieldMyCompanies: FormControl;
  public searchFieldCompaniesYouFollow: FormControl;
  public searchFieldAllCompanies: FormControl;
  public searchFieldRequestedTeams: FormControl;
  public searchFieldTeamsInvitations: FormControl;

  loadingPage: boolean = true;
  loadMyTeams: boolean = true;
  loadExploreTeams: boolean = true;
  loadInviteTeams: boolean = true;
  loadMyCompanies: boolean = true;
  loadingCompaniesYouFollow: boolean = true;
  loadExploreCompanies: boolean = true;

  activeSegment: string = 'teams';
  activeTabSegment: string;

  page = 1;
  exploreTeamsPage = 1;
  totalPages: number;
  teamResponseFlag = false;
  teamInvitationsResponseFlag = false;
  allCompaniesResponseFlag = false;

  myTeams: TeamModel[] = [];
  myTeamsVisible: TeamModel[] = [];
  teamsMemberOf: TeamModel[] = [];
  teamsMemberOfVisible: TeamModel[] = [];

  teamsInvitations = [];
  teamsInvitationVisible = [];


  myCompanies: CompanyModel[] = [];
  myCompaniesVisible: CompanyModel[] = [];
  companiesYouFollow: CompanyModel[] = [];
  companiesYouFollowVisible: CompanyModel[] = [];

  allCompanies: CompanyModel[] = [];
  allCompaniesVisible: CompanyModel[] = [];

  myCompanyPage = 1;
  companiesMemberOfPage = 1;
  allCompaniesPage = 1;

  allTeamResponseFlag = false;
  allTeams = [];
  allTeamsVisible = [];
  allTeamPage = 1;


  loading = false;
  loadingMore = false;
  loadingExploreTeamsPageTimes = 1;
  requestPage = 1;
  pageAllTeam = 1;

  config: SwiperOptions = {
    pagination: true,
    height: 400
  };
  user: UserModel;

  queryAllCompanies = '';

  showMoreMyTeamsButton = false;
  showMoreTeamsMemberOfButton = false;
  showMoreMyCompaniesButton = false;
  showMoreCompaniesYouFollowButton = false;

  showSearchbarMyTeamsValue = false;
  showSearchbarTeamsMemberOfValue = false;
  showSearchbarExploreTeamsValue = false;
  showSearchbarTeamsInvitesValue = false;
  showSearchbarMyCompaniesValue = false;
  showSearchbarExploreCompaniesValue = false;
  showSearchbarCompaniesYouFollowValue = false;

  private initialized: boolean = false;

  constructor(
    private teamService: TeamService,
    private userService: UserService,
    private auth: AuthService,
    private companyService: CompanyService,
    private globalService: GlobalService,
    private searchService: SearchService,
    private navController: NavController
  ) {
    this.searchFieldMyTeams = new FormControl('');
    this.searchFieldTeamsMemberOf = new FormControl('');
    this.searchFieldAllTeams = new FormControl('');
    this.searchFieldMyCompanies = new FormControl('');
    this.searchFieldCompaniesYouFollow = new FormControl('');
    this.searchFieldAllCompanies = new FormControl('');
    this.searchFieldRequestedTeams = new FormControl('');
    this.searchFieldTeamsInvitations = new FormControl('');
  }

  ngOnInit() {
    this.user = this.auth.user;
    this.firstLoadTeams();
    this.firstLoadCompanies();

    this.activeSegment = 'teams';
    this.activeTabSegment = 'myTeams';

    this.globalService.homeScrollTop.subscribe(val => {
      if (val !== null && val === 'team' && this.teamContent !== undefined) {
        this.teamContent.scrollToTop();
        this.firstLoadTeams();
        this.firstLoadCompanies();
      }
    });
  }

  ionViewWillEnter() {
    if (!this.initialized) {
      this.page = 1;
      this.myTeams = [];
      this.teamsMemberOf = [];
      this.loadTeamData();
      this.initialized = true;
    }
  }

  firstLoadTeams() {
    this.loadAllTeams();
    this.loadTeamsInvitations();
  }

  firstLoadCompanies() {
    this.loadMyCompaniesData();
    this.loadCompaniesYouFollow();
    this.loadAllCompanies();
  }

  updatePage() {
    this.loadingPage = true;
    this.page = 1;
    this.myCompanyPage = 1;
    this.companiesMemberOfPage = 1;
    this.allCompaniesPage = 1;
    this.allTeamPage = 1;

    this.showSearchbarMyTeamsValue = false;
    this.showSearchbarTeamsMemberOfValue = false;
    this.showSearchbarExploreTeamsValue = false;
    this.showSearchbarTeamsInvitesValue = false;
    this.showSearchbarMyCompaniesValue = false;
    this.showSearchbarExploreCompaniesValue = false;
    this.showSearchbarCompaniesYouFollowValue = false;

    this.searchFieldMyTeams = new FormControl('');
    this.searchFieldTeamsMemberOf = new FormControl('');
    this.teamsMemberOf = [];
    this.myTeams = [];
    this.loadTeamData();

    if (this.searchFieldAllTeams.value === '') {
      this.loadAllTeams();
    } else {
      this.getSearchAllTeams();
    }

    if (this.searchFieldTeamsInvitations.value === '') {
      this.loadTeamsInvitations();
    } else {
      this.getSearchteamsInvitations();
    }

    this.searchFieldMyCompanies = new FormControl('');
    this.searchFieldCompaniesYouFollow = new FormControl('');
    this.myCompanies = [];
    this.companiesYouFollow = [];
    this.loadMyCompaniesData();
    this.loadCompaniesYouFollow();

    if (this.searchFieldAllCompanies.value === '') {
      this.loadAllCompanies();
    } else {
      this.getSearchAllCompanies();
    }
  }

  loadTeamData() {
    this.loading = true;
    this.loadMyTeams = true;

    this.userService.apiGetTeamListAsAdmin(this.page).subscribe((result: ApiResponse) => {
      if (result.status) {
        for (const data of result.data.data) {
          if (data.isAdmin) {
            if (!this.myTeams.some(elem => elem.id === data.id)) {
              this.myTeams.push(data);
            }
          } else {
            if (!this.teamsMemberOf.some(elem => elem.id === data.id)) {
              this.teamsMemberOf.push(data);
            }
          }
        }

        this.page++;

        if (result.data.pagination.nextPageUrl !== null) {
          this.loadTeamData();
          return;
        } else {
          this.loadMyTeams = false;
        }

        this.loading = false;

        if (this.myTeams.length > 2) {
          this.myTeamsVisible = this.myTeams.slice(0, 2);
          this.showMoreMyTeamsButton = true;

        } else {
          this.myTeamsVisible = this.myTeams;
          this.showMoreMyTeamsButton = false;
        }

        if (this.teamsMemberOf.length > 2) {
          this.teamsMemberOfVisible = this.teamsMemberOf.slice(0, 2);
          this.showMoreTeamsMemberOfButton = true;

        } else {
          this.teamsMemberOfVisible = this.teamsMemberOf;
          this.showMoreTeamsMemberOfButton = false;
        }
      }
      this.loadingPage = false;
    });
  }

  public loadAllTeams(): void {
    if (this.allTeamResponseFlag) return;
    this.allTeamResponseFlag = true;
    this.teamService.apiAllTeamList(this.allTeamPage).subscribe((result: ApiResponse): void => {
      if (result.status) {
        if (this.allTeamPage === 1) {
          this.allTeams = result.data.data;
        } else {
          this.allTeams = [...this.allTeams, ...result.data.data];
        }
        this.allTeamsVisible = [...this.allTeams];
        this.allTeamPage++;
      }
      this.allTeamResponseFlag = false;
      this.loading = false;
      this.loadExploreTeams = false;
    });
  }


  loadMyCompaniesData() {
    this.companyService.apiGetAdminCompanies(this.myCompanyPage)
      .subscribe(result => {
        if (!result.status) return;

        this.myCompanies.push(...result.data.data.filter(d => !this.myCompanies.some(e => e.id === d.id)));
        if (result.data.pagination.currentPage < result.data.pagination.totalPages) {
          this.myCompanyPage++;
          this.loadMyCompaniesData();
        } else {
          this.myCompaniesVisible = this.myCompanies.slice(0, 2);
          this.showMoreMyCompaniesButton = this.myCompanies.length > 2;
          this.loadMyCompanies = false;
        }
      });
  }


  loadCompaniesYouFollow() {
    this.companyService.apiGetUserCompaniesFollows(this.companiesMemberOfPage).subscribe((result: ApiResponse) => {
      if (result.status) {
        for (const data of result.data.data) {
          if (!this.companiesYouFollow.some(elem => elem.id === data.id)) {
            this.companiesYouFollow.push(data);
          }
        }
        this.companiesMemberOfPage++;

        if (result.data.pagination.currentPage < result.data.pagination.totalPages) {
          this.loadCompaniesYouFollow();
          return;
        }
        this.loading = false;

        if (this.companiesYouFollow.length > 2) {
          this.companiesYouFollowVisible = this.companiesYouFollow.slice(0, 2);
          this.showMoreCompaniesYouFollowButton = true;

        } else {
          this.companiesYouFollowVisible = this.companiesYouFollow;
          this.showMoreCompaniesYouFollowButton = false;
        }
      }
      this.loadingCompaniesYouFollow = false;
    });
  }

  loadAllCompanies() {
    if (this.allCompaniesResponseFlag === false) {
      this.allCompaniesResponseFlag = true;
      this.companyService.apiGetCompanies(this.allCompaniesPage).subscribe((result: ApiResponse) => {
        if (result.status) {
          if (this.allCompaniesPage === 1) {
            this.allCompanies = result.data.data;
            this.allCompaniesPage++;
          } else {
            result.data.data.forEach(company => {
              this.allCompanies.push(company);
            });
            this.allCompaniesPage++;
          }
          this.loading = false;
        }
        this.allCompaniesResponseFlag = false;
      });
      this.allCompaniesVisible = this.allCompanies;
      this.loadExploreCompanies = false;
    }
  }

  loadTeamsInvitations() {
    if (this.teamInvitationsResponseFlag === false) {
      this.teamInvitationsResponseFlag = true;
      this.teamService.apiViewInvitationList(1).subscribe((result: ApiResponse) => {
        if (result.status) {
          this.teamsInvitations = result.data.data;
        }
        this.teamsInvitationVisible = this.teamsInvitations;
        this.teamInvitationsResponseFlag = false;
        this.loadInviteTeams = false;
      });
    }
  }

  reloadData(event) {
    if (this.activeSegment === 'teams') {
      if (this.activeTabSegment === 'myTeams') {
        this.loadTeamData();
      } else if (this.activeTabSegment === 'exploreTeams') {
        if (this.searchFieldAllTeams.value === '') {
          this.loadAllTeams();
        } else {
          this.getSearchAllTeams();
        }
      }
    } else if (this.activeSegment === 'companies') {
      if (this.activeTabSegment === 'myCompanies') {
        if (this.searchFieldMyCompanies.value === '') {
          this.loadMyCompaniesData();
        } else {
          this.getSearchMyCompanies();
        }
      } else {
        if (this.searchFieldAllTeams.value === '') {
          this.loadAllCompanies();
        } else {
          this.getSearchAllCompanies();
        }
      }
    }
    setTimeout(() => {
      event.target.complete();
    }, 200)

  }

  doRefresh(event) {
    this.page = 1;
    setTimeout(() => {
      this.updatePage();
      event.target.complete();
    }, 1000);
  }

  getSearchMyTeams() {
    this.myTeamsVisible = this.myTeams;
    if (this.searchFieldMyTeams.value !== '') {
      this.myTeamsVisible = this.myTeams.filter((obj) => obj.name.toLowerCase().includes(this.searchFieldMyTeams.value.toLowerCase()));
    }
    this.showMoreMyTeamsButton = this.myTeamsVisible.length > 2 &&
      this.myTeamsVisible.length < this.myTeams.length;
  }

  getSearchTeamsMemberOf() {
    this.teamsMemberOfVisible = this.teamsMemberOf;
    if (this.searchFieldTeamsMemberOf.value !== '') {
      this.teamsMemberOfVisible = this.teamsMemberOf.filter((obj) => obj.name.toLowerCase().includes(this.searchFieldTeamsMemberOf.value.toLowerCase()));
    }
    this.showMoreTeamsMemberOfButton = this.teamsMemberOfVisible.length > 2 &&
      this.teamsMemberOfVisible.length < this.teamsMemberOf.length;
  }

  getSearchAllTeams() {
    if (this.searchFieldAllTeams.value !== '') {
      if (this.loadingExploreTeamsPageTimes === 1) {
        this.loadingExploreTeamsPageTimes++;
        this.loading = true;
      }
      this.loadingMore = true;
      this.searchService.searchTeams(this.exploreTeamsPage, this.searchFieldAllTeams.value).subscribe((resultAllTeams: ApiResponse) => {
        if (resultAllTeams.status) {
          if (resultAllTeams.data.pagination.currentPage === 1) {
            this.allTeams = resultAllTeams.data.data;
            this.loading = false;
          } else {
            this.allTeams = this.allTeams.concat(resultAllTeams.data.data);
          }
        } else {
          console.log('Error', resultAllTeams.error);
        }
        this.exploreTeamsPage = resultAllTeams.data.pagination.currentPage + 1;
        this.loadingMore = false;
      });
    } else {
      this.loadingExploreTeamsPageTimes = 1;
      this.exploreTeamsPage = 1;
      this.loadAllTeams();
    }
  }

  getSearchteamsInvitations() {
    this.teamsInvitationVisible = this.teamsInvitations;
    if (this.searchFieldTeamsInvitations.value !== '') {
      this.teamsInvitations = this.teamsInvitations.filter((obj) => obj.name.toLowerCase().includes(this.searchFieldTeamsInvitations.value.toLowerCase()));
    }
  }

  getSearchMyCompanies() {
    this.myCompaniesVisible = this.myCompanies;
    if (this.searchFieldMyCompanies.value !== '') {
      this.myCompaniesVisible = this.myCompanies.filter((obj) => obj.name.toLowerCase().includes(this.searchFieldMyCompanies.value.toLowerCase()));
    }
    this.showMoreMyCompaniesButton = this.myCompaniesVisible.length > 2 &&
      this.myCompaniesVisible.length < this.myCompanies.length;
  }

  getSearchCompaniesYouFollow() {
    this.companiesYouFollowVisible = this.companiesYouFollow;
    if (this.searchFieldCompaniesYouFollow.value !== '') {
      this.companiesYouFollowVisible = this.companiesYouFollow.filter((obj) => obj.name.toLowerCase().includes(this.searchFieldCompaniesYouFollow.value.toLowerCase()));
    }
    this.showMoreCompaniesYouFollowButton = this.companiesYouFollowVisible.length > 2 &&
      this.companiesYouFollowVisible.length < this.companiesYouFollow.length;
  }

  getSearchAllCompanies() {
    this.page = 1;
    this.searchService.searchCompanies(this.page, this.searchFieldAllCompanies.value).subscribe((resultAllCompanies: ApiResponse) => {
      if (resultAllCompanies.status) {
        if (this.page === 1) {
          this.allCompaniesVisible = resultAllCompanies.data.data;
        } else {
          this.allCompaniesVisible = this.allCompaniesVisible.concat(resultAllCompanies.data.data);
        }
      }
      this.page++;
      this.loading = false;
    });
  }

  loadMoreMyTeams() {
    const addToVisible = this.myTeams.splice(this.myTeamsVisible.length,
      this.myTeamsVisible.length + this.myTeams.length);
    this.myTeamsVisible = this.myTeamsVisible.concat(addToVisible);
    this.showMoreMyTeamsButton = this.myTeamsVisible.length < this.myTeams.length;
  }

  loadMoreTeamsMemberOf() {
    const addToVisible = this.teamsMemberOf.splice(this.teamsMemberOfVisible.length,
      this.teamsMemberOfVisible.length + this.teamsMemberOf.length);
    this.teamsMemberOfVisible = this.teamsMemberOfVisible.concat(addToVisible);

    this.showMoreTeamsMemberOfButton = this.teamsMemberOfVisible.length < this.teamsMemberOf.length;

  }

  loadMoreMyCompanies() {
    const addToVisible = this.myCompanies.splice(this.myCompaniesVisible.length,
      this.myCompaniesVisible.length + this.myCompanies.length);
    this.myCompaniesVisible = this.myCompaniesVisible.concat(addToVisible);

    this.showMoreMyCompaniesButton = this.myCompaniesVisible.length < this.myCompanies.length;
  }

  loadMoreCompaniesYouFollow() {
    const addToVisible = this.companiesYouFollow.splice(this.companiesYouFollowVisible.length,
      this.companiesYouFollowVisible.length + this.companiesYouFollow.length);
    this.companiesYouFollowVisible = this.companiesYouFollowVisible.concat(addToVisible);

    this.showMoreCompaniesYouFollowButton = this.companiesYouFollowVisible.length < this.companiesYouFollow.length;
  }

  showSearchbarMyTeams() {
    this.showSearchbarMyTeamsValue = !this.showSearchbarMyTeamsValue;
    if (this.showSearchbarMyTeamsValue) {
      setTimeout(() => {
        this.myTeamsSearchBarId.setFocus();
      }, 150);
    }
  }

  showSearchbarTeamsMemberOf() {
    this.showSearchbarTeamsMemberOfValue = !this.showSearchbarTeamsMemberOfValue;
    if (this.showSearchbarTeamsMemberOfValue) {
      setTimeout(() => {
        this.teamsMemberOfSearchbarId.setFocus();
      }, 150);
    }
  }

  showSearchbarExploreTeams() {
    this.showSearchbarExploreTeamsValue = !this.showSearchbarExploreTeamsValue;
    if (this.showSearchbarExploreTeamsValue) {
      setTimeout(() => {
        this.exploreTeamsSearchbarId.setFocus();
      }, 150);
    }
  }

  showSearchbarTeamsInvitation() {
    this.showSearchbarTeamsInvitesValue = !this.showSearchbarTeamsInvitesValue;
    if (this.showSearchbarTeamsInvitesValue) {
      setTimeout(() => {
        this.teamsInvitationsSearchbarId.setFocus();
      }, 150);
    }
  }

  showSearchbarMyCompanies() {
    this.showSearchbarMyCompaniesValue = !this.showSearchbarMyCompaniesValue;
    if (this.showSearchbarMyCompaniesValue) {
      setTimeout(() => {
        this.myCompaniesSearchbarId.setFocus();
      }, 150);
    }
  }

  showSearchbarCompaniesYouFollow() {
    this.showSearchbarCompaniesYouFollowValue = !this.showSearchbarCompaniesYouFollowValue;
    if (this.showSearchbarCompaniesYouFollowValue) {
      setTimeout(() => {
        this.companiesYouFollowSearchbarId.setFocus();
      }, 150);
    }
  }

  showSearchbarExploreCompanies() {
    this.showSearchbarExploreCompaniesValue = !this.showSearchbarExploreCompaniesValue;
    if (this.showSearchbarExploreCompaniesValue) {
      setTimeout(() => {
        this.exploreCompaniesSearchbarId.setFocus();
      }, 150);
    }
  }

  onSlideChange(event) {

    if (event[0].activeIndex === 0) {
      this.activeSegment = 'teams';
    }
    if (event[0].activeIndex === 1) {
      this.activeSegment = 'companies';
    }
  }

  segmentChanged() {
    if (this.activeSegment === 'teams') {
      this.activeSegment = 'companies';
      this.activeTabSegment = 'myCompanies';
    } else {
      this.activeSegment = 'teams';
      this.activeTabSegment = 'myTeams';
    }
  }

  tabSegmentChanged(event) {
    const selectedTab = event.target.value;
    switch (selectedTab) {
      case 'myTeams':
        this.activeTabSegment = 'myTeams';
        this.loadTeamsInvitations();
        break;
      case 'exploreTeams':
        this.page = 1;
        this.activeTabSegment = 'exploreTeams';
        this.loadTeamsInvitations();
        break;
      case 'invites':
        this.activeTabSegment = 'invites';
        this.loadTeamsInvitations();
        break;
      case 'myCompanies':
        this.activeTabSegment = 'myCompanies';
        break;
      case 'exploreCompanies':
        this.loadAllCompanies();
        this.activeTabSegment = 'exploreCompanies';
        break;

      default:
        break;
    }
  }

  createTeam() {
    this.navController.navigateForward(['/app/team/create-team/0']);
  }
}
